module.exports = "<a data-modal=add-to-collection ng-click=toggleCollection()> <svg class=iconic> <use xmlns:xlink=http://www.w3.org/1999/xlink xlink:href=" + require("/var/app/node_modules/ushahidi-platform-pattern-library/assets/img/iconic-sprite.svg") + "#grid-three-up></use> </svg> <span class=label translate=set.add_to_collection>Add to collection</span> </a> ";


//////////////////
// WEBPACK FOOTER
// ./app/main/posts/common/collection-toggle/collection-toggle-link.html
// module id = 805
// module chunks = 0